// src/pages/PoliticaPrivacidad.js
import React from 'react';
import "./LegalPages.css";

function PoliticaPrivacidad() {
  return (
    <div className="legal-page">
      <h1>📌 POLÍTICA DE USO Y PRIVACIDAD - SANTO DOMINGO ESPECTÁCULOS</h1>
      <p>Esta política establece los términos y condiciones de uso de nuestra plataforma, así como las medidas que tomamos para proteger su información personal.</p>
      
      <h2>1. Información que recopilamos</h2>
      <p>Cuando utiliza nuestro sitio web, podemos recopilar información personal y no personal de usted.</p>
      
      <h3>🔹 Información personal:</h3>
      <ul>
        <li>Incluye su nombre, dirección de correo electrónico, número de teléfono y dirección postal.</li>
      </ul>
      
      <h3>🔹 Información no personal:</h3>
      <ul>
        <li>Incluye su dirección IP, tipo de navegador, proveedor de servicios de Internet (ISP), páginas de referencia/salida, tipo de plataforma, fecha/hora y datos de navegación.</li>
      </ul>
      
      <h2>2. Uso de la información</h2>
      <p>La información recopilada se utiliza para:</p>
      <ul>
        <li>✔ Mejorar la experiencia del usuario en nuestro sitio web.</li>
        <li>✔ Procesar pedidos de boletos y ofrecer un servicio eficiente.</li>
        <li>✔ Enviar información promocional y ofertas especiales sobre nuestros eventos.</li>
      </ul>
      
      <h2>3. Compartir información</h2>
      <p>Podemos compartir su información personal con la empresa productora del evento para el cual ha adquirido boletos, exclusivamente para fines relacionados con su compra y asistencia al evento.</p>
      <p>Podemos compartir información no personal con terceros para fines estadísticos, publicitarios y de investigación de mercado.</p>
      <p>No compartimos su información personal con terceros sin su consentimiento previo, a menos que sea requerido por ley o en respuesta a una orden judicial.</p>
      
      <h2>4. Seguridad de la información</h2>
      <p>🔒 En Santo Domingo Espectáculos, tomamos medidas estrictas para proteger su información personal contra:</p>
      <ul>
        <li>✔ Pérdida</li>
        <li>✔ Uso indebido</li>
        <li>✔ Acceso no autorizado</li>
        <li>✔ Divulgación o alteración</li>
      </ul>
      <p>📌 Usamos técnicas de encriptación y cortafuegos para reforzar la seguridad de sus datos.</p>
      
      <h2>5. Uso de Cookies</h2>
      <p>🍪 Utilizamos cookies para mejorar su experiencia en nuestro sitio web.</p>
      <h3>📌 ¿Qué hacen las cookies?</h3>
      <ul>
        <li>Permiten reconocer su dispositivo y personalizar su experiencia.</li>
        <li>Nos ayudan a rastrear el tráfico y recopilar información estadística sobre el uso de la plataforma.</li>
      </ul>
      <p>⚠ Puede desactivar las cookies en la configuración de su navegador, pero esto puede afectar la funcionalidad del sitio web.</p>
      
      <h2>6. Cambios en la Política de Uso y Privacidad</h2>
      <p>Nos reservamos el derecho de modificar esta Política de Uso y Privacidad en cualquier momento.</p>
      <p>📌 Cualquier cambio será publicado en nuestro sitio web y entrará en vigencia inmediatamente.</p>
      
      <h2>7. Contacto</h2>
      <p>Si tiene preguntas sobre nuestra Política de Uso y Privacidad, puede comunicarse con nosotros a través de nuestro formulario de contacto en el sitio web.</p>
    </div>
  );
}
export default PoliticaPrivacidad;
